import { type Clip } from '@air/api/types';
import { ClipUtils } from '@air/utils-clips';

import { type SetBoardThumbnailModalProps } from '~/components/Modals/SetBoardThumbnail/SetBoardThumbnailModal';
import { isRiveFile } from '~/utils/RiveUtils';

type CanShowSetBoardThumbnailMenuParams = {
  canSetThumbnail: boolean;
  clipType: Clip['type'];
  excludeRive: boolean;
  ext: string;
};

export const canShowSetBoardThumbnailMenu = ({
  canSetThumbnail,
  clipType,
  excludeRive,
  ext,
}: CanShowSetBoardThumbnailMenuParams) => {
  if (!canSetThumbnail) {
    return false;
  }

  if (!ClipUtils.canHavePreviewImage(clipType)) {
    return false;
  }

  if (excludeRive && isRiveFile({ ext })) {
    return false;
  }

  return true;
};

type GetSetBoardThumbnailMenuSelectParams = {
  canSetThumbnail: boolean;
  clip: Pick<Clip, 'assets' | 'ext' | 'id' | 'type'>;
  excludeRive: boolean;
  showSetBoardThumbnailModal: (props: SetBoardThumbnailModalProps) => void;
};

export const getSetBoardThumbnailMenuSelect = ({
  canSetThumbnail,
  clip,
  excludeRive,
  showSetBoardThumbnailModal,
}: GetSetBoardThumbnailMenuSelectParams) => {
  if (
    !canShowSetBoardThumbnailMenu({
      canSetThumbnail,
      clipType: clip.type,
      excludeRive,
      ext: clip.ext,
    })
  ) {
    return undefined;
  }

  return () =>
    showSetBoardThumbnailModal({
      clip,
      trackLocation: 'asset-details',
    });
};
